export const guestCopy = {
  welcomeMorning: "Good morning",
  welcomeAfternoon: "Good afternoon",
  welcomeEvening: "Good evening",
  welcomeBanner:
    "We’re delighted to have you with us. How can we make your stay exceptional today?",
  searchPlaceholder: "Search services, food, or hotel info…",
  needHelp: "Need help?",
  whatHappensNext: "What happens next",
  requestSent: "Request sent",
  requestFailed: "Could not send that request. Please try again.",
  moreLanguages: "More languages coming soon",
  diningHubHint: "Order from your table, see specials, or call a waiter.",
  roomHubHint: "Food, room care, buffet hours, and hotel help — all from your room.",
  emptySearch: "Nothing matched. Try towels, breakfast, Wi-Fi, or a dish name.",
  etaPrefix: "Usually",
  minutes: "min",
  deliverTo: "Deliver to",
  roomDining: "Room dining",
  dineIn: "Dine in",
  backToHub: "Back to services",
  language: "EN",
};
